export default __webpack_public_path__ + "static/media/press_button.63848126.mp3";